import styled, { css } from 'styled-components';
import { colors } from 'styles/colors';

const Burger = styled.button`
   position: relative;
   display: block;
   width: 40px;
   height: 40px;
   background: none;
   border: none;
   transform: rotate(0);
   transition: all 0.25s ease-in-out;

   &:focus {
      outline: 0;
   }

   &::before,
   &::after {
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      display: block;
      width: 22px;
      height: 2px;
      background: ${colors.primary};
      transition: all 0.25s ease-in-out;
   }

   &::before {
      transform: translate(-50%, calc(-50% - 3px)) rotate(0);
   }

   &::after {
      transform: translate(-50%, calc(-50% + 3px)) rotate(0);
   }

   ${({ active }) =>
      active &&
      css`
         transform: rotate(180deg);

         &::before {
            transform: translate(-50%, -50%) rotate(-45deg);
         }

         &::after {
            transform: translate(-50%, -50%) rotate(45deg);
         }
      `}
`;

export default Burger;
